export const helpHeaderComponent = (helpHeaderWrapper: HTMLFormElement) => {
  console.log('test')

  const checkInput = (e: Event) => {
    const inputElement = helpHeaderWrapper.querySelector('.js-helpSearchForm-input') as unknown as HTMLInputElement

    if (inputElement.value === '') {
      e.preventDefault()
    }
  }

  helpHeaderWrapper.addEventListener('submit', (e: Event) => {
    checkInput(e)
  })

  const submitElement = helpHeaderWrapper.querySelector('.js-helpSearchForm-submit') as unknown as HTMLInputElement

  submitElement.addEventListener('click', (e: Event) => {
    checkInput(e)
  })
}
